var dom = {};

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var setupDom = function(){

	dom.document = $(document);

};

var addEventHandlers = function(){

	dom.document.on('click', '.work-sample-item', function(){

		console.log('send him to: ' + $(this).attr('data-work-sample-id'));

		window.location = 'work/' + $(this).attr('data-work-sample-id');

	});

};

init = function(){

	setupDom();

	addEventHandlers();

};

init();